import Lookup from 'src/componentes/select2';

const ContratoLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/ContratoLookup"
    clearable={true}
    {...rest}
  />
);

export default ContratoLookup;
